// extracted by mini-css-extract-plugin
export var addViewLink = "_d-2";
export var availabilityIcon = "_d-17";
export var availabilitySelectionIcon = "_d-16";
export var backButton = "_d-3";
export var backIcon = "_d-10";
export var conversationCount = "_d-4";
export var dragHandle = "_d-6";
export var dropdown = "_d-f";
export var dropdownIcon = "_d-8";
export var dropdownOption = "_d-7";
export var dropdownTriangle = "_d-e";
export var expand = "_d-g";
export var folder = "_d-j";
export var folderItem = "_d-d";
export var icon = "_d-9";
export var iconRow = "_d-a";
export var image = "_d-b";
export var logo = "_d-c";
export var navContainer = "_d-i";
export var navigationFooter = "_d-h";
export var pageShell = "_d-0";
export var pageShellWms = "_d-1";
export var placeholderAvailable = "_d-12";
export var placeholderBox = "_d-15";
export var placeholderBusy = "_d-14";
export var placeholderUnavailable = "_d-13";
export var profile = "_d-l";
export var profileContainer = "_d-n";
export var profileDropdown = "_d-o";
export var profileImage = "_d-m";
export var profileMain = "_d-p";
export var profileSubtitle = "_d-r";
export var profileTitle = "_d-q";
export var reorderIcon = "_d-s";
export var sentLine = "_d-v";
export var settingsHeader = "_d-t";
export var sidenavTextColor = "_d-z";
export var spamLine = "_d-u";
export var subitemWithTag = "_d-5";
export var supportItems = "_d-k";
export var teamText = "_d-11";
export var viewLine = "_d-y";
export var viewLineButton = "_d-x";
export var viewLineButtons = "_d-w";